import { createSelector } from 'reselect';

import {
  MERCADO_PAGO,
  DECIDIR,
  INGENICO,
  EXTERNAL,
  SPREEDLY,
  WEBPAY_ONE_CLICK,
} from '@commons/utils/payment/paymentGatewayTypeConstants';
import { getCountryShortName } from '@shared/selectors';
import { COUNTRY_SHORT_NAME } from '@commons/constants';
import { getPaymentProvidersByPartner } from './getPaymentProviderByPartner';

export const getPaymentGatewayTypeByCountry = createSelector(
  getPaymentProvidersByPartner,
  getCountryShortName,
  (paymentProviders, countryShortName) => {
    const {
      ARGENTINA,
      CHILE,
      PANAMA,
      PARAGUAY,
      URUGUAY,
      BOLIVIA,
      COLOMBIA,
      DOMINICANAN_REPUBLIC,
      VENEZUELA,
      ECUADOR,
      PERU,
      COSTA_RICA,
      EL_SALVADOR,
      GUATEMALA,
      HONDURAS,
    } = COUNTRY_SHORT_NAME;

    const getSpreedlyProviderOrDefault = (providers, fallback) =>
      providers?.find(
        paymentProvider =>
          paymentProvider === SPREEDLY || paymentProvider === WEBPAY_ONE_CLICK,
      ) || fallback;

    switch (countryShortName) {
      case CHILE:
        return getSpreedlyProviderOrDefault(paymentProviders, MERCADO_PAGO);
      case ARGENTINA:
        return getSpreedlyProviderOrDefault(paymentProviders, DECIDIR);
      case BOLIVIA:
      case PARAGUAY:
      case PANAMA:
      case COSTA_RICA:
        return getSpreedlyProviderOrDefault(paymentProviders, INGENICO);
      case URUGUAY:
        return EXTERNAL;
      case COLOMBIA:
      case DOMINICANAN_REPUBLIC:
      case VENEZUELA:
      case ECUADOR:
      case PERU:
      case EL_SALVADOR:
      case GUATEMALA:
      case HONDURAS:
        return SPREEDLY;
      default:
        return null;
    }
  },
);

export default getPaymentGatewayTypeByCountry;
